(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsMyID', StatsMyID);

    StatsMyID.$inject = ['$resource', 'DateUtils'];

    function StatsMyID($resource) {
        var resourceUrl = 'api/stats-my-id-count';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
